import { FC } from "react";
import { Box, CircularProgress, Theme } from "@mui/material";

interface Props {
  theme: Theme;
}

export const Loading: FC<Props> = ({ theme }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: theme.palette.primary.main,
          marginBottom: theme.spacing(3)
        }}
      />
    </Box>
  );
};
